// @flow
import RadioSelect from 'fg-frontend/src/components/RadioSelect';
import Slider from 'fg-frontend/components/Slider';
import NumberInput from 'fg-frontend/components/NumberInput';
import SimpleCollapse from 'fg-frontend/components/SimpleCollapse';
import UniversalPaginationButton from 'fg-frontend/components/UniversalPaginationButton';
import ListToggle from 'fg-frontend/components/ListToggle';
import Typeahead from 'fg-frontend/components/Typeahead';
import FulltextAutocomplete from 'fg-frontend/components/FulltextAutocomplete';
import PasswordToggle from 'fg-frontend/components/PasswordToggle';
import SocialShare from 'fg-frontend/components/SocialShare';
import RangeDatepicker from 'fg-frontend/components/RangeDatepicker';
import AnchorsList from 'fg-frontend/src/components/AnchorsList';
import RadioSelectTab from 'fg-frontend/src/components/RadioSelectTab';
import GreedyMenu from 'fg-frontend/components/GreedyMenu';
import ShareUrl from 'fg-frontend/src/components/ShareUrl';
import PrintPage from 'fg-frontend/src/components/PrintPage';
import PrintPdf from 'fg-frontend/src/components/PrintPdf';
import RedirectToUrl from 'fg-frontend/src/components/RedirectToUrl';
import Form from 'fg-frontend/src/components/Form';
import Webslider from 'fg-frontend/src/components/Webslider';
import FileInput from 'fg-frontend/src/components/FileInput';
import RangeSlider from 'fg-frontend/src/components/RangeSlider';
import { Datepicker } from 'fg-frontend/src/components/Datepicker';
import 'flatpickr/dist/l10n/cs';
import CustomSimpleCollapse from './components/CustomSimpleCollapse';
import DataSort from './components/DataSort';
import Oauth2BrianLogin from './components/Oauth2BrianLogin';
import AddSvgIconSprite from './components/AddSvgIconSprite';
import Tooltip from './components/Tooltip';
import GtmHandler from './components/GtmHandler';
import TriggerInViewport from './components/TriggerInViewport';
import LazyImage from './components/LazyImage';
import PhotoSwipe from './components/PhotoSwipe';
import Countdown from './components/Countdown';
import Toggler from './components/Toggler';
import TogglerCustom from './components/TogglerCustom';
import FGUpload from './components/FGUpload';
import ShowMorePhotos from './components/ShowMorePhotos'
import configureEshopComponents from './configureEshopComponents';

export default (props) => {
  switch (props.decorator || props.is) {
    case 'Oauth2BrianLogin':
      return Oauth2BrianLogin;
    case 'AddSvgIconSprite':
      return AddSvgIconSprite;
    case 'RadioSelect':
    case 'CheckboxSelect':
      return RadioSelect;
    case 'SimpleCollapse':
      return SimpleCollapse;
    case 'CustomSimpleCollapse':
      return CustomSimpleCollapse;
    case 'DataSort':
      return DataSort;
    case 'GreedyMenu':
      return GreedyMenu;
    case 'Typeahead':
      return Typeahead;
    case 'ListToggle':
      return ListToggle;
    case 'PasswordToggle':
      return PasswordToggle;
    case 'SocialShare':
      return SocialShare;
    case 'AnchorsList':
      return AnchorsList;
    case 'FulltextAutocomplete':
      return FulltextAutocomplete;
    case 'Slider':
      return Slider;
    case 'RadioSelectTab':
      return RadioSelectTab;
    case 'NumberInput':
      return NumberInput;
    case 'UniversalPaginationButton':
      return UniversalPaginationButton;
    case 'Tooltip':
      return Tooltip;
    case 'GtmHandler':
      return GtmHandler;
    case 'TriggerInViewport':
      return TriggerInViewport;
    case 'ShareUrl':
      return ShareUrl;
    case 'PhotoSwipe':
      return PhotoSwipe;
    case 'RedirectToUrl':
      return RedirectToUrl;
    case 'Form':
      return Form;
    case 'LazyImage':
      return LazyImage;
    case 'Webslider':
      return Webslider;
    case 'Countdown':
      return Countdown;
    case 'Toggler':
      return Toggler;
    case 'TogglerCustom':
      return TogglerCustom;
    case 'PrintPage':
      return PrintPage;
    case 'PrintPdf':
      return PrintPdf;
    case 'FileInput':
      return FileInput;
    case 'FGUpload':
      return FGUpload;
    case 'ShowMorePhotos':
      return ShowMorePhotos;
    case 'RangeSlider':
      return RangeSlider;
    case 'RangeDatepicker':
      return RangeDatepicker;
	case 'Datepicker':
     return Datepicker;
    default:
      const eshopComponent = configureEshopComponents(props);
      if (eshopComponent) {
	return eshopComponent;
      } else {
        console.log(`Unknown component ${props.decorator || props.is}`);
        return null;
      }
  }
};



// WEBPACK FOOTER //
// ./fe/web-default/src/js/configureWebComponents.js